import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';
import {useSnackbar} from 'notistack';
import {useAddProvinceMutation, useGetCountriesQuery} from 'api';
import ProvinceForm from './ProvinceForm';

function CreateProvinceModal({open, onClose}) {
  const {data, isLoading, isError} = useGetCountriesQuery();
  const formRef = React.useRef();
  const [addProvince] = useAddProvinceMutation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const {enqueueSnackbar} = useSnackbar();
  return (
    <Dialog fullWidth scroll="body" maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle mb={2} variant="h6">
        Create Province
      </DialogTitle>
      <DialogContent>
        <ProvinceForm
          disabled={isLoading || isError}
          countriesList={data || []}
          ref={formRef}
          onSubmit={async (values, actions) => {
            try {
              setIsSubmitting(true);

              const newObj = {
                ...values,
              };
              await addProvince(newObj).unwrap();
              actions.resetForm();
              enqueueSnackbar('Province created successfully', {
                variant: 'success',
              });
              onClose();
            } catch (e) {
              const message =
                e.status === 400 ? e.provinceResponse?.details?.[0]?.message : undefined;
              enqueueSnackbar(message || 'Failed to create Province', {
                variant: 'error',
              });
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} color="inherit" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          endIcon={isSubmitting ? <CircularProgress ml={2} size={16} /> : null}
          disabled={isSubmitting}
          color="primary"
          variant="contained"
          onClick={() => formRef.current?.submit?.()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateProvinceModal;
